const billingFrequency = {
  daily: 'Day',
  monthly: 'Month',
  quarterly: 'Quarter',
  yearly: 'Annual',
};

export const stripeBillingPeriods = {
  day: 'day',
  week: 'week',
  month: 'month',
  year: 'year',
};

const billingFrequencySortOrder = Object.fromEntries(
  Object.values(billingFrequency).map((v, i) => [v, i]),
);

// Longest billing period first. Equal periods keep their original order, and unrecognized periods
// sort last.
export function sortByBillingPeriod(a, b) {
  return (
    (billingFrequencySortOrder[b?.billingPeriod] ?? -1) -
    (billingFrequencySortOrder[a?.billingPeriod] ?? -1)
  );
}

export default billingFrequency;
